import * as R from 'ramda'
import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectFunnelStartTime = state => {
    return selectOwnState(state).funnelStartTime
}

export const selectFunnelStepList = state => {
    return selectOwnState(state).funnelStepList
}

export const selectCohortList = state => {
    return selectOwnState(state).cohortList
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectMode = state => {
    return selectOwnState(state).mode
}

export const selectFirstFunnelStep = state => {
    const funnelStepList = selectFunnelStepList(state)
    return funnelStepList[0]
}

export const selectCurrentState = state => {
    return selectOwnState(state).currentState
}

export const selectEnrichedStateList = (state) => {
    const currentState = selectCurrentState(state)
    if (!currentState) {
        return
    }
    let total = 0
    R.forEach(state => {
        total += state.count
    }, currentState)

    return currentState.map(state => {
        return {
            ...state,
            percentage: (100 * state.count / total),
        }
    })
}

export const selectFilteredStateList = (state) => {
    const currentState = selectEnrichedStateList(state)
    if (!currentState) {
        return
    }
    return currentState.filter(state => {
        return (state.percentage) > 3
    })
}

export const selectCohortByProcessNameAndState = (state, processName, stateName) => {
    const cohortList = selectCohortList(state)
    for (let index = 0; index < cohortList.length; index++) {
        const cohort = cohortList[index]
        if ((cohort.processName === processName) && (cohort.stateName === stateName)) {
            return cohort
        }
    }
    return null
}


export const selectEnrichedStepList = state => {
    const enrichedList = []
    const funnelStepList = selectFunnelStepList(state)
    R.forEach(funnelStep => {
        const cohort = selectCohortByProcessNameAndState(state, funnelStep.processName, funnelStep.stateName)

        enrichedList.push({
            ...funnelStep,
            total: cohort ? cohort.total : 0,
            data: cohort ? {
                ...cohort.data,
            } : {},
        })
    }, funnelStepList)

    return enrichedList
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/funnel-builder/selector.js